import { render } from "./PadroesSeguracaMeuQueridometro.vue?vue&type=template&id=8ddf9756&scoped=true"
import script from "./PadroesSeguracaMeuQueridometro.vue?vue&type=script&lang=js"
export * from "./PadroesSeguracaMeuQueridometro.vue?vue&type=script&lang=js"

import "./PadroesSeguracaMeuQueridometro.vue?vue&type=style&index=0&id=8ddf9756&scoped=true&lang=css"

import exportComponent from "/home/frog/Documents/vue/AeAAppDev/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ddf9756"]])

export default __exports__